var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTryAgainDarkRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_2966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2887 8.694C13.1628 9.65397 12.7779 10.5616 12.1754 11.3194C11.5729 12.0773 10.7755 12.6569 9.86864 12.996C8.96178 13.3351 7.97972 13.421 7.02777 13.2444C6.07583 13.0678 5.18991 12.6354 4.46504 11.9935C3.74016 11.3517 3.20368 10.5247 2.91312 9.6011C2.62256 8.67754 2.58888 7.6923 2.8157 6.75106C3.04253 5.80981 3.52129 4.94807 4.20065 4.25824C4.88001 3.56841 5.73434 3.07652 6.672 2.83533C9.27133 2.16867 11.962 3.50667 12.9553 6",
    stroke: "#8B0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.66667V6H10",
    stroke: "#8B0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_2966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTryAgainDarkRed);
export default __webpack_public_path__ + "static/media/Icon_TryAgain_DarkRed.9881715b41e9781687831323d8815697.svg";
export { ForwardRef as ReactComponent };